// extracted by mini-css-extract-plugin
var _1 = "bLRq618brwpo6WChmW0b";
export { _1 as "text" }
